import * as types from './mutation-types'
import boardComponents from '../../services/boardComponents'
import { createServiceCall } from '../actionsUtil'

export const getBoardComponent = createServiceCall({
  mainAction: types.GET_BOARD_COMPONENT_REQUEST,
  serviceFunction: boardComponents.getBoardComponent,
  successAction: types.GET_BOARD_COMPONENT_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_BOARD_COMPONENT_FAILURE
})

export const getBoardComponentTypes = createServiceCall({
  mainAction: types.GET_BOARD_COMPONENT_TYPES_REQUEST,
  serviceFunction: boardComponents.getBoardComponentTypes,
  successAction: types.GET_BOARD_COMPONENT_TYPES_SUCCESS,
  successDataPropery: '',
  failureAction: types.GET_BOARD_COMPONENT_TYPES_FAILURE
})

export const storeBoardComponent = createServiceCall({
  mainAction: types.ADD_BOARD_COMPONENT_REQUEST,
  serviceFunction: boardComponents.storeBoardComponent,
  successAction: types.ADD_BOARD_COMPONENT_SUCCESS,
  successDataPropery: '',
  failureAction: types.ADD_BOARD_COMPONENT_FAILURE
})

export const updateBoardComponent = createServiceCall({
  mainAction: types.UPDATE_BOARD_COMPONENT_REQUEST,
  serviceFunction: boardComponents.updateBoardComponent,
  successAction: types.UPDATE_BOARD_COMPONENT_SUCCESS,
  successDataPropery: '',
  failureAction: types.UPDATE_BOARD_COMPONENT_FAILURE
})
